const columns = [
  { name: "Curso", value: "courseName", filter: false },
  { name: "Nome do material", value: "materialName", filter: false },
  { name: "Tempo", value: "time", filter: false },
  { name: "Data", value: "convertDate", filter: false },
];

export { columns };
